import React from 'react';
import { useNavigate } from 'react-router-dom';

const BottomNav = ({ active }) => {
    const navigate = useNavigate();

    const handleNavigation = (path) => {
        if (localStorage.getItem('qc_pending') === 'true') {
            alert("Please complete or skip the QC checklist before leaving.");
            return;
        }
        navigate(path);
    };

    return (
        <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-100 z-50 shadow-[0_-10px_30px_rgba(0,0,0,0.03)] focus:bg-white active:bg-white outline-none">
            <div className="flex items-center justify-center gap-x-16 py-4 max-w-md mx-auto">

                {/* Home */}
                <button
                    onClick={() => handleNavigation('/home')}
                    className={`flex flex-col items-center space-y-1 transition-colors ${active === 'home' ? 'text-teal-600' : 'text-gray-400'}`}
                >
                    <svg className="w-7 h-7" fill={active === 'home' ? 'currentColor' : 'none'} stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
                    </svg>
                    <span className="text-[10px] font-bold uppercase tracking-tight">Home</span>
                    {active === 'home' && <div className="w-10 h-[3px] bg-teal-500 rounded-full mt-0.5"></div>}
                </button>

                {/* Logs */}
                <button
                    onClick={() => handleNavigation('/logs')}
                    className={`flex flex-col items-center space-y-1 transition-colors ${active === 'logs' ? 'text-teal-600' : 'text-gray-400'}`}
                >
                    <svg className="w-7 h-7" fill={active === 'logs' ? 'currentColor' : 'none'} stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                    <span className="text-[10px] font-bold uppercase tracking-tight">Logs</span>
                    {active === 'logs' && <div className="w-10 h-[3px] bg-teal-500 rounded-full mt-0.5"></div>}
                </button>


            </div>
        </nav>
    );
};

export default BottomNav;
